import React from 'react';
import { Fragment } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import brasao from '../../assets/images/brasao.png';
import '../../styles/footer.scss';

function Footer() {
    return (
        <Fragment>
            <footer className='rodape'>
                <Container>
                    <Row xs={1}>
                        <Col>
                            <img src={brasao} className="brasao-ft" alt="Prefeitura de Macuco" />
                        </Col>
                        <Col>
                            <p className="pref-ft">Prefeitura de <span className='upper'>Macuco</span></p>
                        </Col>
                    </Row>
                    <Row xs={1}>
                        <Col>
                            <p className="text-ft">Rua Doutor Mário Freire Martins, 100 - Centro - Macuco - RJ - CEP 28545-000
                                Telefone (22) 2554-9100</p>
                            <p className="text-ft">Horário de Atendimento: Segunda à Sexta-feira, das 9h às 17h</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="dev-by">Desenvolvido por: Departamento de Tecnologia da Informação</p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </Fragment>
    )
}

export default Footer;